module.exports = __webpack_public_path__ + "ar.no2.85a05aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ar.no2.jpg
// module id = gzTY
// module chunks = 0